import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';

import { AuthProvider } from '@/lib/auth/auth-provider';
import { queryClient } from '@/lib/query/client';
import { applyThemeClass, useThemeStore } from '@/lib/theme/theme-store';
import { router } from '@/routes';
import './styles/globals.css';

// Sync the document class with the resolved boot theme before first
// paint so there's no light→dark flash for dark-mode users.
applyThemeClass(useThemeStore.getState().theme);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find #root element — index.html is malformed.');
}

createRoot(rootElement).render(
  <StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster richColors position="top-right" />
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>,
);
